/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Bonus } from '../../models/bonus';

export interface CreateLoyaltyProgramBonus$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
      body: Bonus
}

export function createLoyaltyProgramBonus(http: HttpClient, rootUrl: string, params: CreateLoyaltyProgramBonus$Params, context?: HttpContext): Observable<StrictHttpResponse<Bonus>> {
  const rb = new RequestBuilder(rootUrl, createLoyaltyProgramBonus.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Bonus>;
    })
  );
}

createLoyaltyProgramBonus.PATH = '/loyalty/programs/{programId}/bonuses';
